import React, { useState } from "react";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
import InputFieldV2 from "../../../lib/input/InputFieldV2";
import { createCribSheetFormData } from "../../../data/formData";
import CribSheetList from "./CribSheetList";
import DeleteCribSheetPopup from "../locationDetail/DeleteCribSheetPopup";
import { makeDeleteCall } from "../../../effects/requests";
import { endPoints } from "../../../utils/endpoints";
import { emptyFunction, showToast } from "../../../utils";
import { ApiResponseType } from "../../../types";
interface CribEntry {
    id: string;
    headline: string;
    description: string;
    isEdit?: boolean
}

interface Props {
    entries: CribEntry[];
    setEntries: React.Dispatch<React.SetStateAction<CribEntry[]>>;
    onRefresh: () => void;
}

const StepCribSheet: React.FC<Props> = ({ entries, setEntries, onRefresh }) => {

    const [selectedId, setSelectedId] = useState<any>(null)
    const [editIdx, setEditIdx] = useState<any>(null)

    const methods = useForm({
        mode: 'all',
        defaultValues: { ...createCribSheetFormData() },
        reValidateMode: 'onBlur',
    });

    const onSubmit: SubmitHandler<any> = (data: any) => {
        const tempEnteries = [...entries];
        if (editIdx || editIdx == 0) {
            const exitingObj = tempEnteries[editIdx]
            const editObj = {
                ...exitingObj,
                headline: data.headline,
                description: data.description,
                isEdit: exitingObj?.id ? true : false
            }
            tempEnteries[editIdx] = editObj;
        } else {
            tempEnteries.push({
                id: '',
                headline: data.headline,
                description: data.description,
                isEdit: false
            })
        }
        setEntries(tempEnteries);
        methods.reset({
            headline: "",
            description: "",
        });
    };

    const handleEdit = (entry: CribEntry, idx: any) => {
        methods.reset({
            headline: entry.headline,
            description: entry.description,
        });
        setEditIdx(idx);
    };

    const handleDelete = () => {
        const url = `${endPoints.LOCATION_CRIB}${selectedId}/`
        makeDeleteCall(url).then((res: ApiResponseType<any>) => {
            if (res?.status?.code === 200) {
                showToast(res?.status?.message, "success")
                onRefresh();
                setEditIdx(null);
                setSelectedId(null)
            }
        }).catch(emptyFunction)
    };

    return (
        <FormProvider {...methods}>
            <div className="cl-step">
                <h3 className="cl-step__heading">Add Crib Sheet</h3>

                <CribSheetList
                    entries={entries}
                    setDeleteEntry={(entry, idx) => {
                        if (entry?.id) {
                            setSelectedId(entry?.id);
                            return
                        }
                        const tempEntry = [...entries];
                        tempEntry.splice(idx, 1)
                        setEntries(tempEntry);
                        methods.reset({
                            headline: "",
                            description: "",
                        });
                    }}
                    setEditEntry={handleEdit}
                />

                <div className="cl-step__fields">
                    <InputFieldV2
                        name="headline"
                        label="Headline"
                        placeholder="Enter Headline"
                        type="text"
                        rules={{
                            required: "Headline is required",
                        }}
                    />

                    <InputFieldV2
                        name="description"
                        label="Description"
                        placeholder="Enter Description"
                        type="text"
                        rules={{
                            required: "Description is required",
                        }}
                        isTextArea
                        maxLength={10000}
                    />
                </div>

                <div className="crib-actions">
                    <button
                        type="button"
                        className="crib-actions__save"
                        onClick={methods.handleSubmit(onSubmit)}
                    >
                        Save & Add Another
                    </button>

                    {/* <button
                        type="button"
                        className="crib-actions__add-another"
                        onClick={handleAddAnother}
                    >
                        + Add Another
                    </button> */}
                </div>
            </div>
            {selectedId &&
                <DeleteCribSheetPopup
                    onClose={() => {
                        setSelectedId(null);
                        setEditIdx(null)
                    }}
                    onDelete={handleDelete}
                />
            }
        </FormProvider>
    );
};

export default StepCribSheet;